import TaskList from '@tiptap/extension-task-list';

// Stock TaskList binds Mod-Shift-9 to the raw toggleTaskList command, which
// bypasses this app's toggleTaskListSafely conversion logic (list-type-conversion.ts).
// KeyboardShortcuts (keyboard-shortcuts.ts) owns Mod-Shift-7/8/9 instead.
export const TaskListNoShortcut = TaskList.extend({
  addKeyboardShortcuts() {
    return {};
  },
});
